// extracted by mini-css-extract-plugin
module.exports = {"value_wrapper":"OurValue_value_wrapper__30t2W"};